import React, { useCallback, useEffect, useState } from "react";
import SITE from "@/constants/site";
import SITE_IDS from "@/constants/testIds/site";

const scrollToId = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Nav() {
  const [solid, setSolid] = useState(false);

  const handleScroll = useCallback(() => {
    setSolid(window.scrollY > window.innerHeight * 0.9);
  }, []);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <header className={`nav ${solid ? "nav--solid" : ""}`}>
      <div className="nav__inner">
        <a
          href="#top"
          data-testid={SITE_IDS.navHome}
          className="nav__brand font-display"
          onClick={scrollToId("top")}
        >
          {SITE.monogram}
        </a>
        <nav className="nav__links">
          <a href="/story" className="nav__link">
            The Weekend
          </a>
          <a
            href="#keepsakes"
            data-testid={SITE_IDS.navGallery}
            className="nav__link"
            onClick={scrollToId("keepsakes")}
          >
            Gallery
          </a>
          <a
            href="#credits"
            data-testid={SITE_IDS.navCredits}
            className="nav__link"
            onClick={scrollToId("credits")}
          >
            Credits
          </a>
          <a
            href={SITE.links.gallery}
            data-testid={SITE_IDS.navRsvpCta}
            className="nav__cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Photos
          </a>
        </nav>
      </div>
    </header>
  );
}
